class EditSystemGroup {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.editSystemGroupEvents();
    }
    editSystemGroupEvents(){
        const thisClass = this;
        /** When user click on edit button redraw modal form and get system group values */
        $(document).on('click', '.edit-system-group', function(e) {
            let groupID = $(this).parent()[0].id;
            thisClass.showEditSystemGroupModal(groupID);
        });
        /** If url contains #edit-system-group - show group */
        if(window.location.href.includes('edit-system-group') && new URLSearchParams(window.location.search).get('systemGroupID')){
            let groupID = new URLSearchParams(window.location.search).get('systemGroupID');
            thisClass.showEditSystemGroupModal(groupID);
        }
    }
    /** Redraw edit group form by systemGroupID */
    showEditSystemGroupModal(systemGroupID){
        new ModalLoading();
        naja.makeRequest('GET', '/systems/?do=getSystemGroupInfo', {
            'systemGroupID': systemGroupID,
            'organizationID': this.organizationID
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if(response){
                let editSystemGroupModal = document.getElementById('edit_system_group_modal');
                this.hideGeneralModals(editSystemGroupModal);

                new SystemGroupForm('frm-generalForms-editSystemGroupForm-editSystemGroupForm', response.systemGroupInfo);
                new ModalLoading(editSystemGroupModal);
            }
        }).catch(error => {
            new ModalLoading();
            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
        });
    }
    hideGeneralModals(editSystemGroupModal){
        let editAccessCardModal = document.getElementById('edit_access_card_modal');
        if(editAccessCardModal && editAccessCardModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editAccessCardModal).hide();
            new AddBackLinkToModal(editAccessCardModal, editSystemGroupModal);
        }
        let createAccessCardModal = document.getElementById('create_access_card_modal');
        if(createAccessCardModal && createAccessCardModal.classList.contains('show')){
            bootstrap.Modal.getInstance(createAccessCardModal).hide();
            new AddBackLinkToModal(createAccessCardModal, editSystemGroupModal);
        }
        let editSystemModal = document.getElementById('edit_system_modal');
        if(editSystemModal && editSystemModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editSystemModal).hide();
            new AddBackLinkToModal(editSystemModal, editSystemGroupModal);
        }
    }
}
window.EditSystemGroup = EditSystemGroup;